import React, { useState, useEffect, useRef } from 'react';
import uniqid from 'uniqid';
import BookingFormStore from 'Stores/BookingFormStore';
import BookingComponent from 'Components/Front/BookingComponent';
import VerifyPaymentToken from 'Components/Front/Booking/BookingPaymentTokenVerification';
import Loader from 'Pure/Loader';
import getBookingIdentifier from 'Functions/getBookingIdentifier';
import removeGetParameter from 'Functions/removeGetParameter';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { action } from 'Shared/Routes';
import { service_categories } from 'Shared/options';
import getServiceBookingErrors from '../../../../../FullStack/Shared/getServiceBookingErrors';
import { getUrlParameter, isTrue, num, formatNum, isFalse, getBookingHoursCount } from 'Shared/utilities';
const {
  app
} = window;
export default function BookingComponentInit(props) {
  const [need_update, setNeedUpdate] = useState(false);
  const [session_changed, setSessionChanged] = useState(false);
  const [session_id, setSessionId] = useState();
  const services = BookingFormStore.useState(s => s.services);
  const oauth = BookingFormStore.useState(s => s.oauth);

  // le formulaire étant en pullstate et n'étant pas forcément écouté ici,
  // déclenche un re render
  const [init, setInit] = useState(false);
  const _ref_form_ready = useRef(); // formulaire prêt à être initialisé
  const _ref_init = useRef(); // formulaire initialisé

  const _ref_services_fetched = useRef(); // services disponibles

  const _ref_date = useRef();
  const _ref_roles = useRef();
  const _ref_login = useRef();
  useEffect(function () {
    _ref_roles.current = app.state.session?.user?.roles || [];
    _ref_login.current = app.state.session?.user?.login;
    app.push({
      event: 'sessionChange',
      cb: handleSessionChange
    });
    return () => {
      app.delete({
        event: 'sessionChange',
        cb: handleSessionChange
      });
    };
    function handleSessionChange({
      event,
      source
    }) {
      const roles_changed = rolesChanged(_ref_roles.current, app.state.session?.user?.roles);
      const login_changed = _ref_login.current !== app.state.session?.user?.login;
      if (!roles_changed && !login_changed) {
        return;
      }
      _ref_roles.current = app.state.session?.user?.roles || [];
      _ref_login.current = app.state.session?.user?.login;
      setSessionChanged(true);
    }
  }, []);
  useEffect(function () {
    if (!props.date) return;
    const date_changed = _ref_date.current === props.date;

    // date changée ou premier render
    if (date_changed || props.date && !_ref_init.current) {
      setNeedUpdate(true);
      return;
    }
    _ref_date.current = props.date;
  }, [props.date, session_changed]);
  useEffect(function () {
    if (!need_update) return;
    (async function handleSessionChange() {
      await fetchServices();
      await checkNewsletter();
      const user_session = app.state.session.user || {};
      const roles = Array.isArray(user_session.roles) ? user_session.roles : [];
      const is__customer = roles.includes('customer');
      const update = {
        is_customer: is__customer,
        b2b: !is__customer && roles.includes('company_employee'),
        logged_in: user_session.login ? true : false
      };
      if (is__customer) {
        Object.assign(update, {
          'user[login]': user_session.login || '',
          'user[lastname]': user_session.lastname || '',
          'user[firstname]': user_session.firstname || '',
          'user[phone_number]': user_session.phone_number || '',
          create_account: false
        });
      }
      BookingFormStore.update(function (store) {
        Object.keys(update).forEach(field => store[field] = update[field]);
        _ref_form_ready.current = true;
        setSessionId(uniqid());
      });
    })();
  }, [need_update]);
  useEffect(function formStoreInit() {
    if (init || _ref_init.current) return;
    if (!_ref_form_ready.current) return;
    const roles = Array.isArray(app.state.session?.user?.roles) ? app.state.session.user.roles : [];
    BookingFormStore.update(function (store) {
      ['date', 'people', 'start', 'end', 'amount', 'disposition'].forEach(field => store[field] = props[field]);
      store.hours_count = getBookingHoursCount({
        date: props.date,
        start_hour: props.start,
        end_hour: props.end,
        coworking_space: props.space
      });
      store.grand_total = num(props.amount);
      store.status_messages = {};
      store.oauth_login_error = isFalse(getUrlParameter('exists')) ? 'Compte introuvable, inscrivez-vous via la section « Nouveau client ».' : undefined;
      if (isTrue(getUrlParameter('already_registered'))) {
        store.oauth_register_error = 'Vous avez déjà un compte, connectez-vous via la section « Déjà client »';
      }
      store.oauth = isTrue(getUrlParameter('oauth'));
      store.oauth_register = isTrue(getUrlParameter('oauth')) && isTrue(getUrlParameter('register')) && !isTrue(getUrlParameter('already_registered'));
      store.oauth_strategy = getUrlParameter('strategy');
      store.logged_in = app.state.session?.user?.login ? true : false;
      store.booking_id = window.localStorage.getItem('current_booking_id');
      store.b2b = roles.includes('company_employee');
      if (!roles.includes('company_employee')) {
        store.step = props.people > 0 === false ? -1 : window.localStorage.getItem('current_booking_id') ? 2 : getBookingIdentifier() === window.localStorage.getItem('services_picked') ? 1 : 0;
      }
      store.seats_error = props.people > 0 === false;
      store.continue_as_guest = function () {
        const is__auth = app.state.session.user?.id ? true : false;
        const is__customer = (app.state.session.user?.roles || []).includes('customer');
        if (is__auth && !is__customer) {
          return true;
        }
        if (!is__auth) {
          const has_discount_code = num(window.localStorage.getItem('booking_discount_code_discounted')) > 0;
          if (has_discount_code) return true;
        }
        return false;
      }();
      store.source = props.source;
      removeGetParameter('exists');
      removeGetParameter('register');
      removeGetParameter('strategy');
      removeGetParameter('oauth');
      removeGetParameter('already_registered');
      _ref_init.current = true;
      setInit(true);
    });
  }, [init, props, session_id]);
  useEffect(function () {
    const services_amount = (services || []).reduce(function (amount, service) {
      return num(amount + num(service.total_price));
    }, 0);
    BookingFormStore.update(function (store) {
      const amount = num(window.localStorage.getItem('amount'));
      store.amount = formatNum(amount, '0.00');
      store.grand_total = num(amount + services_amount);
    });
  }, [services]);
  if (!init) {
    return /*#__PURE__*/React.createElement("div", {
      className: "booking-loader-container"
    }, /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BookingComponent, props), /*#__PURE__*/React.createElement(VerifyPaymentToken, null));
  function checkNewsletter(e) {
    const email = app.state.session?.user?.login;
    if (!email) return;
    BookingFormStore.update(s => {
      s.loading = true;
    });
    (async function () {
      try {
        var response = await ajaxRequest(action('IsInNewsletter'), {
          data: {
            email: email
          }
        });
      } catch (update) {
        BookingFormStore.update(function (store) {
          Object.keys(update).forEach(field => store[field] = update[field]);
        });
        return;
      }
      BookingFormStore.update(function (store) {
        store.loading = false;
        store.in_newsletter = isTrue(response.is__subscribed);
        store.newsletter_subscription = isTrue(response.is__subscribed);
      });
    })();
  }
  async function fetchServices(e) {
    if (_ref_services_fetched?.current) return;
    BookingFormStore.update(s => {
      s.loading = true;
    });
    const roles = Array.isArray(app.state.session?.user?.roles) ? app.state.session.user.roles : [];
    if (roles.includes('company_employee')) {
      const booking_id = window.localStorage.getItem('current_booking_id');
      booking_id ? props.stepChange?.(2) : props.stepChange?.(1);
      BookingFormStore.update(function (store) {
        store.step = booking_id ? 2 : 1;
        store.loading = false;
      });
      _ref_services_fetched.current = true;
      return;
    }
    try {
      var response = await ajaxRequest(action('getAllServices'), {
        data: {
          date: props.date,
          space_id: props.space.id,
          with_count: true,
          front: true
        }
      });
      _ref_services_fetched.current = true;
    } catch (update) {
      _ref_services_fetched.current = true;
      BookingFormStore.update(function (store) {
        Object.keys(update).forEach(field => store[field] = update[field]);
      });
      return;
    }
    const booking_id = window.localStorage.getItem('current_booking_id');
    let step = booking_id ? 2 : 1;
    const passed_services = getBookingIdentifier() === window.localStorage.getItem('services_picked');
    const available_services = (response.data || []).filter(function (service) {
      const is__available = getServiceBookingErrors({
        date: props.date,
        start_hour: props.start,
        end_hour: props.end,
        coworking_space: props.space
      }, service);
      return is__available === true;
    });
    if (available_services.length > 0 && !oauth && !passed_services) {
      step = 0;
    }
    const services_by_category = available_services.reduce(function (grouped, service) {
      const category = service._servicetitle?.__category;
      if (!grouped[category?.value || '']) {
        grouped[category?.value || ''] = [];
      }
      grouped[category?.value || ''].push(service);
      return grouped;
    }, {});
    let session_services = [];
    if ([0, 1, 2].includes(step) && available_services.length > 0) {
      try {
        const data = JSON.parse(window.localStorage.getItem('services_details') || '[]');
        if (Array.isArray(data)) {
          session_services = data;
        }
      } catch (e) {
        session_services = [];
      }
    }
    BookingFormStore.update(function (store) {
      store.loading = false;
      store.step = step;
      store.have_services = available_services.length > 0;
      store.booking_id = booking_id;
      store.services_by_category = services_by_category;
      store.services_count = available_services.length || 0;
      const picked_services = {};
      available_services.forEach(function (service) {
        const session_qty = session_services.find(data => data.id === service.id)?.qty;
        picked_services['qty_' + service.id] = formatNum(session_qty, '0');
      });
      store.picked_services = picked_services;
      store.services_categories = Object.keys(services_by_category).map(function (id) {
        const category = service_categories.find(opt => opt.value === id) || {
          value: ''
        };
        const data = {
          ...category,
          __services: services_by_category[id]
        };
        return data;
      });
    });
    props.stepChange?.(step);
  }
}
function rolesChanged(prev_roles, new_roles) {
  if (prev_roles?.length !== new_roles?.length) return true;
  return (prev_roles || []).some(role => !(new_roles || []).includes(role));
}
